import './details';
import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from '../src/dbh_helper';

if (dbh_helper.getUrlArea() == "adressen") {
    $(document).ready(function () {
    });
}

export class AdressHandler {
    getPartner = function (id: string): Promise<Array<IPartner>> {
        return new Promise(function (resolve, reject) {
            new dbh_ajax().sendGetRequest({
                actionName: "GetPartner",
                controllerName: "Adressen",
                parameter: [["id", id]],
                callbackSuccess: (ajaxResult: Array<IPartner>) => {
                    resolve(ajaxResult);
                },
                callbackError: (ajaxResult: object) => {
                    console.log(ajaxResult);
                    reject(ajaxResult);
                }
            });
        });
    }
}

export interface IPartner {
    adressgruppe: string;
    anrede: string;
    vorname: string;
    name: string;
    firma1: string;
    firma2: string;
    amt1: string;
    amt2: string;
    pK_Adressen: string;
}